export default __webpack_public_path__ + "130bf87f7812c1734bdf3f7963d52e4f.png";